import { Component, effect, inject, input, model, ModelSignal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DropdownField, EmailField, TagField, TextField } from '@eventlyte/forms';
import {
	COUNTRY_SERVICE,
	RegistrationCountryField,
	RegistrationPhoneNumberField
} from '@eventlyte/registration';
import { TranslocoDirective } from '@jsverse/transloco';
import { take } from 'rxjs';

@Component({
	selector: 'app-registration-group-page-record',
	imports: [
		TextField,
		TranslocoDirective,
		DropdownField,
		TagField,
		RegistrationCountryField,
		RegistrationPhoneNumberField,
		EmailField
	],
	templateUrl: './registration-group-page-record.html',
	styleUrls: ['./registration-group-page-record.scss']
})
export class RegistrationGroupPageRecord {
	public record = model<Record<string, unknown>>({});
	public formGroup = input.required<FormGroup>();
	public recordIndex = input.required<number>();

	private countryService = inject(COUNTRY_SERVICE);

	constructor() {
		effect(() => {
			const placeOfResidence = this.getRecordValue(this.record, 'placeOfResidence');

			this.countryService
				.getCountries()
				.pipe(take(1))
				.subscribe((countries) => {
					const country = countries.find((c) => c.code === placeOfResidence);

					const currentMobile = this.getRecordValue(this.record, 'mobileNumber');
					const targetMobile = country ? '+' + country.dialingCode : undefined;

					if (country && !currentMobile?.startsWith('+' + country.dialingCode)) {
						this.setRecordValue(this.record, 'mobileNumber', targetMobile);
					}
				});
		});
	}

	protected getRecordValue(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		record: ModelSignal<Record<string, any>>,
		key: string
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	): any | undefined {
		return record()[key];
	}

	protected setRecordValue(
		record: ModelSignal<Record<string, unknown>>,
		key: string,
		value: unknown | undefined
	): void {
		record.set({ ...record(), [key]: value });
	}
}
